import actionFe from 'utils/mw/actionFe.util';

const feUpdateTimeOffData = actionFe('feUpdateTimeOffData');

// noinspection JSUnusedGlobalSymbols
export default feUpdateTimeOffData;
